type ShiftChatTypes = 'chat' | 'text';
type ShiftEventTypes = 'chatImpression' | 'chatClick' | 'chatMessage' | 'chatLead' | 'chatClosed';

interface ShiftClickPayload {
    chatType: ShiftChatTypes;
}

interface ShiftMessagePayload {
    chatSessionId: string;
    chatMessageType: 'user' | 'agent';
    chatMessageContent: string;
}

interface ShiftLeadPayload {
    chatSessionId: string;
    chatLeadId: string;
}

interface ShiftClosedPayload {
    chatSessionId: string;
}

type ShiftPayloads = ShiftClickPayload | ShiftMessagePayload | ShiftLeadPayload | ShiftClosedPayload;

/**
 * Handles notifying Shift of a chat impression.
 */
export function handleChatImpression() {
    sendEvent('chatImpression');
}

/**
 * Handles notifying Shift of a user opening the chat.
 */
export function handleChatClick(type: ShiftChatTypes) {
    sendEvent('chatClick', {
        chatType: type,
    });
}

/**
 * Handles notifying Shift of a user sending/receiving a chat message.
 */
export function handleChatMessage(chatId: string, message: string, isVisitor: boolean) {
    sendEvent('chatMessage', {
        chatSessionId: chatId,
        chatMessageType: isVisitor ? 'user' : 'agent',
        chatMessageContent: message,
    });
}

/**
 * Handles notifying Shift of a chat lead.
 */
export function handleChatLead(chatId: string, leadId: string) {
    sendEvent('chatLead', {
        chatSessionId: chatId,
        chatLeadId: leadId,
    });
}

/**
 * Handles notifying Shift of a user closing the chat.
 */
export function handleChatClosed(chatId: string) {
    sendEvent('chatClosed', {
        chatSessionId: chatId,
    });
}

/**
 * Service to handle sending notifications to Shift if the provider is present
 * in the global window scope.
 */
function sendEvent(event: ShiftEventTypes, data?: ShiftPayloads) {
    const shiftProvider = (window as any).sd;
    if (typeof shiftProvider !== 'function') {
        return;
    }

    const payload = {
        events: event,
        chatProvider: 'Dealer Inspire',
        chatProfitCenter: 'sales',
        chatType: 'chat',
        ...data
    };

    shiftProvider('dataLayer', payload);
    shiftProvider('send');
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/shiftTagging.ts